var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.clickable)?_c('button',_vm._g({},_vm.listeners),[_vm._t("default")],2):_c('span',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }